module.exports = __webpack_public_path__ + "assets/off-view.2470e69a.svg";